import { render, staticRenderFns } from "./ViewCareer.vue?vue&type=template&id=2b5af0b1"
import script from "./ViewCareer.vue?vue&type=script&lang=js"
export * from "./ViewCareer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports